import logo from '@/assets/logo-tinymdm-HD-500.png';
import { SPECIFIC_PARTNER_BG_BANNER } from '@/features/login/Login.tsx';
import { useParticlesOptions } from '@/features/login/useParticlesOptions.ts';
import i18n, { availableLocales } from '@/i18n/i18n.ts';
import {
  Button,
  getCurrentReadableLocaleShortName,
  Paper,
  PossibleLocalesType,
  Typography,
} from '@arsnovasystems/ars-front-lib';
import { Box, Stack } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router';

export const LoginLayout = () => {
  const navigate = useNavigate();
  const options = useParticlesOptions();
  const { t } = useTranslation();
  useEffect(() => {
    // eslint-disable-next-line i18next/no-literal-string
    window.particlesJS('particles-js', options);
  }, [options]);
  return (
    <Box
      sx={{
        height: '100%',
        position: 'relative',
        backgroundColor: '#222637',
      }}
    >
      <Box
        sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: '18px' }}
        id='particles-js'
      ></Box>
      <Stack
        sx={{
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Paper
          sx={() => ({
            width: '400px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 5,
            '& > div': {
              width: '100%',
            },
          })}
        >
          <Button
            variant={'outlined'}
            size={'small'}
            sx={(theme) => ({
              position: 'absolute',
              top: theme.spacing(1),
              right: theme.spacing(1),
            })}
            onClick={() => {
              const languageIdx = availableLocales.indexOf(
                i18n.language as PossibleLocalesType,
              );
              const nextLanguageIdx =
                (languageIdx + 1) % availableLocales.length;
              const nextLanguage = availableLocales[nextLanguageIdx];

              void i18n.changeLanguage(nextLanguage);
            }}
          >
            {getCurrentReadableLocaleShortName()}
          </Button>
          <Button
            variant={'text'}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
            onClick={() => {
              void navigate('/login');
            }}
          >
            <img
              width={100}
              alt='TinyMDM Logo'
              src={logo}
            />

            <Typography
              variant={'subtitle2'}
              sx={(theme) => ({
                letterSpacing: '4px',
                fontSize: '1.4rem',
                fontWeight: 600,
                color: theme.palette.secondary.contrastText,
                backgroundColor: SPECIFIC_PARTNER_BG_BANNER,
                textTransform: 'uppercase',
                paddingX: 1,
                width: 'fit-content',
              })}
            >
              {t('Partner')}
            </Typography>
          </Button>
          <Outlet />
        </Paper>
      </Stack>
    </Box>
  );
};
